import MainPage from "../pages/MainPage";
import ConstantsPage from "../pages/Constants/ConstantsPage";
import DepartmentsPage from "../pages/Departments/DepartmentsPage";
import ConstIDPage from "../pages/Constants/ConstIDPage";
import ConstEditPage from "../pages/Constants/ConstEditPage";
import LoginPage from "../pages/LoginPage";
import DepIdPage from "../pages/Departments/DepIdPage";
import DepEditPage from "../pages/Departments/DepEditPage";
import DepAddPage from "../pages/Departments/DepAddPage";
import AdminsPage from "../pages/Admin/AdminsPage";
import AdminAddPage from "../pages/Admin/AdminAddPage";
import AdminIdPage from "../pages/Admin/AdminIdPage";
import AdminEditPage from "../pages/Admin/AdminEditPage";
import ProfilePage from "../pages/ProfilePage";
import StudentsPage from "../pages/Students/StudentsPage";
import StudAddPage from "../pages/Students/StudAddPage";
import StudIdPage from "../pages/Students/StudIdPage";
import StudEditPage from "../pages/Students/StudEditPage";
import TeachersPage from "../pages/Teachers/TeachersPage";
import TeachAddPage from "../pages/Teachers/TeachAddPage";
import TeachIdPage from "../pages/Teachers/TeachIdPage";
import TeachEditPage from "../pages/Teachers/TeachEditPage";
import CoursesPage from "../pages/CoursesPage";
import CourseAddPage from "../pages/CourseAddPage";
import CourseIdPage from "../pages/CourseIdPage";
import CourseEditPage from "../pages/CourseEditPage";
import ManageStudentsPage from "../pages/ManageStudentsPage";

//export по идее не нужен, но на всякий написал
//позже нужно будеть разделть на publicRoutes, privateRoutes
//для не авторизованного и авторизованного пользователя
//руты полностью могу сам сделать

export const privateRoutes = [
    {path: '/main', component:<MainPage/>, export: true},
    {path: '/constants', component:<ConstantsPage/>, export: true},
    {path: '/constants/:id', component: <ConstIDPage/>, export: true},
    {path: '/constants/:id/edit', component: <ConstEditPage/>, export: true},
    {path: '/departments', component: <DepartmentsPage/>, export:true},
    {path: '/departments/:id', component: <DepIdPage/>, export:true},
    {path: '/departments/:id/edit', component: <DepEditPage/>, export:true},
    {path: '/departments/add', component: <DepAddPage/>, export:true},
    {path: '/admins', component:<AdminsPage/>, export: true},
    {path: '/admins/add', component:<AdminAddPage/>, export: true},
    {path: '/admins/:id', component:<AdminIdPage/>, export: true},
    {path: '/admins/:id/edit', component:<AdminEditPage/>, export: true},
    {path: '/profile', component:<ProfilePage/>, export: true},
    {path: '/students', component:<StudentsPage/>, export: true},
    {path: '/students/add', component:<StudAddPage/>, export: true},
    {path: '/students/:id', component:<StudIdPage/>, export: true},
    {path: '/students/:id/edit', component:<StudEditPage/>, export: true},
    {path: '/teachers', component:<TeachersPage/>, export: true},
    {path: '/teachers/add', component:<TeachAddPage/>, export: true},
    {path: '/teachers/:id', component:<TeachIdPage/>, export: true},
    {path: '/teachers/:id/edit', component:<TeachEditPage/>, export: true},
    {path: '/courses', component: <CoursesPage/>, export: true},
    {path: '/courses/add', component: <CourseAddPage/>, export: true},
    {path: '/courses/:id', component: <CourseIdPage/>, export: true},
    {path: '/courses/:id/edit', component: <CourseEditPage/>, export: true},
    {path: '/courses/:id/manage-students', component:<ManageStudentsPage/>, export: true},
]

export const publicRoutes = [
    { path: '/login', component: <LoginPage /> }
];